import { render, staticRenderFns } from "./BatchTreeNodeDialog.vue?vue&type=template&id=0b7464c8&"
import script from "./BatchTreeNodeDialog.vue?vue&type=script&lang=js&"
export * from "./BatchTreeNodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7464c8')) {
      api.createRecord('0b7464c8', component.options)
    } else {
      api.reload('0b7464c8', component.options)
    }
    module.hot.accept("./BatchTreeNodeDialog.vue?vue&type=template&id=0b7464c8&", function () {
      api.rerender('0b7464c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/BatchTreeNodeDialog.vue"
export default component.exports